import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';



const LiveCount = () => {

  let { location_id } = useParams();

  const [percent, setPercent] = useState(0);
  const [allowed_capacity_number, setAllowedCapacityNumber] = useState(0);
  const [current_occupancy, setCurrentOccupancy] = useState(0);

  const getOccupancy = () => {
    
    if(location_id) { 
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
  
      axios({
        method: 'GET',
        url: `https://app.doortally.com/api/v1/live/${location_id}`,
        data: null,
        config,
      })
        .then((res) => {
          if (res.data.Success === true) {
  
            setAllowedCapacityNumber(res.data.Data.allowed_capacity_number)
            setCurrentOccupancy(res.data.Data.current_occupancy)
  
            if (Number(res.data.Data.current_occupancy) === 0) {
              setPercent(0);
            } else {
              let new_percent = (Number(res.data.Data.current_occupancy) / Number(res.data.Data.allowed_capacity_number) * 100);
              new_percent = new_percent.toFixed(0);
  
              if (percent !== new_percent) {
                setPercent(new_percent);
              }
            } 
  
          }
        })
        .catch((error) => {
        }); 
    }
 
  }

  useEffect(() => { 
    getOccupancy(); 
    const interval = setInterval(() => {
      getOccupancy(); 
    }, 60000);
    return () => clearInterval(interval);
  } ); 

  return (
    <div className="App">
      <header className="App-header">
        <p>
          Current Occupancy
    </p>
        <div style={{ "width": '60%', "paddingBottom": "30px" }} >
          <CircularProgressbar value={percent} text={`${current_occupancy} / ${allowed_capacity_number}`} />
        </div>
        <a
          href={`https://doortally.com?utm_source=embed&utm_medium=banner&utm_campaign=${location_id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="poweredby.png" className="dt-logo" alt="logo" style={{ "width": '50%' }} />
        </a>
      </header>
    </div>
  );
};

export default LiveCount;